<template>
  <div>
    <v-lazy>
      <apexchart type="donut" height="120" :options="chartOptions" :series="series"></apexchart>
    </v-lazy>
    <div class="d-flex align-center mt-3">
      <span class="individualDot mr-2">●</span>
      <span class="text mr-4">Individual</span>
      <span class="aggregateDot mr-2">●</span>
      <span class="text">Agregados</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      series: [
        this.aggregateAccountsPercentage,
        this.individualAccountsPercentage
      ],
      chartOptions: {
        chart: {
          type: "donut",
          fontFamily: "Montserrat, sans-serif"
        },
        labels: ["Agregados", "Individuais"],
        colors: ["#B7000C", "#6464FF"],
        dataLabels: {
          enabled: false
        },
        legend: {
          show: true,
          showForSingleSeries: false,
          showForNullSeries: true,
          showForZeroSeries: true,
          position: "right",
          horizontalAlign: "right",
          floating: false,
          fontSize: "14px",
          fontFamily: "Montserrat, sans-serif",
          fontWeight: 400,
          formatter: function(seriesName, opts) {
            return [
              seriesName,
              ":",
              `<strong>${opts.w.globals.series[opts.seriesIndex]}%</strong>`
            ];
          },
          inverseOrder: true,
          width: undefined,
          height: undefined,
          tooltipHoverFormatter: undefined,
          offsetX: 30,
          offsetY: 30,
          labels: {
            colors: ["#9E9E9E"],
            useSeriesColors: true
          },
          markers: {
            width: 0,
            height: 0,
            strokeWidth: 0,
            strokeColor: undefined,
            fillColors: "transparent",
            radius: 0,
            customHTML: undefined,
            onClick: undefined,
            offsetX: 0,
            offsetY: 0
          },
          itemMargin: {
            horizontal: 0,
            vertical: 10
          },
          onItemClick: {
            toggleDataSeries: false
          },
          onItemHover: {
            highlightDataSeries: true
          }
        },
        stroke: {
          show: false,
          width: 2,
          colors: ["transparent"]
        },
        plotOptions: {
          pie: {
            customScale: 1,
            offsetX: -30,
            offsetY: 30,
            expandOnClick: false,
            dataLabels: {
              offset: 0,
              minAngleToShowLabel: 10
            },
            donut: {
              size: "70%",
              background: "transparent"
            }
          }
        }
      }
    };
  },
  props: {
    aggregateAccountsPercentage: {
      type: Number,
      required: true
    },
    individualAccountsPercentage: {
      type: Number,
      required: true
    }
  }
};
</script>

<style scoped>
.individualDot {
  color: #6464ff;
  font-size: 12px;
}
.aggregateDot {
  color: #b7000c;
  font-size: 12px;
}
.text {
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.32px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #9e9e9e;
}
</style>